import React, { Component } from "react";
import Functions from "../../../src/functions";
import CustomFunctions from "../../../modules/functions";
import Manager from "../../../src/manager";

class AvailableData extends Component {
	state = {
		data: [],
		control: null,
		loaded: false,
		delay: 2000,
	};

	constructor(props) {
		super(props);

		this.createDataList = this.createDataList.bind(this);
		this.getOs = this.getOs.bind(this);
		this.tryToOpenDeepLinkOrRedirect =
			this.tryToOpenDeepLinkOrRedirect.bind(this);
		this.openDeepLink = this.openDeepLink.bind(this);
		this.redirectOrActivateAndRedirect =
			this.redirectOrActivateAndRedirect.bind(this);
	}

	componentDidMount() {
		this.setState({
			control: this.props.control,
			loaded: true,
			data: this.props.data,
		});
		this.interval = setInterval(this.fetchPollingOrderStatus, this.state.delay);
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevState.delay !== this.state.delay) {
			clearInterval(this.interval);
			this.interval = setInterval(
				this.fetchPollingOrderStatus,
				this.state.delay,
			);
		}
	}

	componentWillUnmount() {
		clearInterval(this.interval);
	}

	fetchPollingOrderStatus() {
		const url = CustomFunctions.restAPI("/service/checkOrderStatus");
		if (sessionStorage.getItem("pendingStatus") === "PENDING") {
			fetch(url, { method: "POST" })
				.then((res) => res.json())
				.then((data) => {
					sessionStorage.setItem("rli", data.item.rli);
					sessionStorage.setItem("pendingStatus", data.item.status);
				})
				.catch(function () {
					clearInterval(this.interval);
				});
		} else {
			clearInterval(this.interval);
		}
	}

	textAsideOfPackages() {
		let text;
		let UserType = Functions["custom"]["getUserType"]();
		let landPageData = JSON.parse(sessionStorage.landPageData);
		let residential = JSON.parse(sessionStorage.getItem("residential"));
		let isActive = landPageData.contractInfoCarrier.isActive;
		let hasDP =
			UserType === "POSTR" &&
			landPageData.contractInfoCarrier.inListOfWhatuspCss
				? landPageData.contractInfoCarrier.hasDP
				: null;
		let hasInternet = landPageData.contractInfoCarrier.hasInternet;
		let hasActivePass = JSON.parse(sessionStorage.getItem("hasActivePass"));
		let volumeChargeIsActive = false;
		let extraIsActive = false;
		let dayPassIsActive = false;
		let hoursIsActive = false;
		let weekendIsActive = false;

		this.state.data.map((itm, idx) => {
			if (isActive) {
				if (itm.type === "VOLUME_CHARGE") {
					volumeChargeIsActive = true;
				} else if (itm.type === "EXTRA") {
					extraIsActive = true;
				} else if (itm.type === "DAY_PASS") {
					dayPassIsActive = true;
				} else if (itm.type === "HOURS") {
					hoursIsActive = true;
				} else if (itm.type === "WEEKEND") {
					weekendIsActive = true;
				}
			}
		});

		if (hasInternet && hasDP === false) {
			if (extraIsActive || hoursIsActive || weekendIsActive) {
				text = "Έχετε επιλέξει";
			} else if (volumeChargeIsActive) {
				if (residential.indexOf(UserType) !== -1) {
					text = "Για περισσότερο σερφάρισμα στο Internet επιλέξτε";
				} else {
					text = "Για περισσότερη πλοήγηση στο Internet επιλέξτε";
				}
			} else {
				if (residential.indexOf(UserType) !== -1) {
					text = "Για να συνεχίσετε τo σερφάρισμα επιλέξτε";
				} else {
					text = "Για να συνεχίσετε την πλοήγηση επιλέξτε";
				}
			}
		} else if (!hasInternet && hasDP) {
			if (dayPassIsActive) {
				if (residential.indexOf(UserType) !== -1) {
					text = "Για περισσότερο σερφάρισμα στο Internet επιλέξτε";
				} else {
					text = "Για περισσότερη πλοήγηση στο Internet επιλέξτε";
				}
			} else {
				if (residential.indexOf(UserType) !== -1) {
					text = "Για να σερφάρετε στο Internet επιλέξτε";
				} else {
					text = "Για να πλοηγηθείτε στο Internet επιλέξτε";
				}
			}
		} else {
			if (residential.indexOf(UserType) !== -1) {
				if (
					UserType === "POSTR" &&
					!landPageData.contractInfoCarrier.inListOfWhatuspCss
				) {
					text = "Για περισσότερο σερφάρισμα στο Internet επιλέξτε";
				} else {
					text = "Για να σερφάρετε στο Internet επιλέξτε";
				}
			} else {
				text = "Για να πλοηγηθείτε στο Internet επιλέξτε";
			}
		}
		if (
			UserType === "PREPAID_COSMOKARTA" ||
			UserType === "PREPAID_FROG" ||
			UserType === "PREPAID_WHATSUP" ||
			UserType === "HYBRID_BUSINESS_COST_CONTROL" ||
			UserType === "HYBRID_RESIDENTIAL_COST_CONTROL"
		) {
			let listOfDataBuckets = this.props.restData.item.listOfDataBuckets;
			let totalDataBalance = this.props.restData.item.totalDataBalance;
			let listOfUnlimitedDataPrepaidNinja =
				this.props.restData.item.listOfUnlimitedDataPrepaidNinja;

			if (totalDataBalance === 0) {
				if (
					listOfUnlimitedDataPrepaidNinja.length > 0 &&
					listOfDataBuckets.length > 0
				) {
					let detailsOnly = 1;
					for (let j = 0; j < listOfDataBuckets.length; j++) {
						for (let i = 0; i < listOfUnlimitedDataPrepaidNinja.length; i++) {
							if (
								listOfDataBuckets[j].name ==
								listOfUnlimitedDataPrepaidNinja[i].bucket
							) {
								if (!listOfUnlimitedDataPrepaidNinja[i].detailsOnly) {
									detailsOnly = 0;
									break;
								}
							}
						}
					}
					if (detailsOnly == 0) {
						return (
							<td valign="middle">
								<span className="customeClassSideMessageAvailableMBs">
									{UserType === "HYBRID_BUSINESS_COST_CONTROL"
										? "Για περισσότερο σερφάρισμα στο Internet επιλέξτε"
										: UserType === "HYBRID_RESIDENTIAL_COST_CONTROL"
											? "Για περισσότερο σερφάρισμα στο Internet επίλεξε"
											: "Για περισσότερο σερφάρισμα ενεργοποίησε εδώ το πακέτο που θέλεις:"}
								</span>
							</td>
						);
					} else {
						return (
							<td valign="middle">
								<span className="customeClassSideMessageNoMBs">
									{UserType === "HYBRID_BUSINESS_COST_CONTROL"
										? "Για να συνεχίσετε να σερφάρετε στο Internet επιλέξτε"
										: UserType === "HYBRID_RESIDENTIAL_COST_CONTROL"
											? "Για να συνεχίσεις να σερφάρεις στο Internet επίλεξε"
											: "Για να ξεκινήσεις το σερφάρισμα ενεργοποίησε εδώ το πακέτο που θέλεις:"}
								</span>
							</td>
						);
					}
				} else {
					return (
						<td valign="middle">
							<span className="customeClassSideMessageNoMBs">
								{UserType === "HYBRID_BUSINESS_COST_CONTROL"
									? "Για να συνεχίσετε να σερφάρετε στο Internet επιλέξτε"
									: UserType === "HYBRID_RESIDENTIAL_COST_CONTROL"
										? "Για να συνεχίσεις να σερφάρεις στο Internet επίλεξε"
										: "Για να ξεκινήσεις το σερφάρισμα ενεργοποίησε εδώ το πακέτο που θέλεις:"}
							</span>
						</td>
					);
				}
			} else {
				// available remaining MBs
				return (
					<td valign="middle">
						<span className="customeClassSideMessageAvailableMBs">
							{UserType === "HYBRID_BUSINESS_COST_CONTROL"
								? "Για περισσότερο σερφάρισμα στο Internet επιλέξτε"
								: UserType === "HYBRID_RESIDENTIAL_COST_CONTROL"
									? "Για περισσότερο σερφάρισμα στο Internet επίλεξε"
									: "Για περισσότερο σερφάρισμα ενεργοποίησε εδώ το πακέτο που θέλεις:"}
						</span>
					</td>
				);
			}
		} else if (UserType === "NEO") {
			return <td></td>;
		}

		if (
			UserType === "POSTR" ||
			UserType === "POSTB" ||
			UserType === "POSTB_SPLIT"
		) {
			let availableMBs = JSON.parse(sessionStorage.getItem("totalRemainingMB"));
			if (availableMBs !== null) {
				if (!hasActivePass && availableMBs > 0) {
					if (residential.indexOf(UserType) !== -1) {
						text = "Για περισσότερο σερφάρισμα στο Internet επιλέξτε";
					} else {
						text = "Για περισσότερη πλοήγηση στο Internet επιλέξτε";
					}
				}
			}
		}

		return (
			<td
				valign="middle"
				className="selection-message customeClassSideMessageNoMBs"
				id="selection-message-id">
				{text}
			</td>
		);
	}

	createDataList() {
		let output = [];
		let UserType = Functions["custom"]["getUserType"]();
		let landPageData = JSON.parse(sessionStorage.landPageData);
		let isSupportedMobile = null;
		if (UserType !== "NEO") {
			isSupportedMobile = this.isSupportedMobile();
		}
		if (isSupportedMobile) {
			console.log("User is banner eligible. Creating banner.");
			let upElement = document.getElementsByClassName("header")[0];
			if (
				UserType === "POSTR" ||
				UserType === "POSTB" ||
				UserType === "POSTB_SPLIT" ||
				UserType === "HYBRID_BUSINESS_COST_CONTROL" ||
				(UserType === "HYBRID_RESIDENTIAL_COST_CONTROL" &&
					!landPageData.contractInfoCarrier.inListOfWhatuspCss)
			) {
				upElement.insertAdjacentHTML(
					"afterend",
					'<div className="home-banner" id="home-banner"><img' +
						' src="./resources/images/banner.png"/></div>',
				);

				setTimeout(() => {
					document.getElementById("home-banner").style.cursor = "pointer";
					document
						.getElementById("home-banner")
						.addEventListener("click", this.tryToOpenDeepLinkOrRedirect);
				}, 2000);
			}
		}
		this.state.data.map((itm, idx) => {
			output.push(
				<div
					className="more-links"
					key={idx}>
					{itm.modal.component}
				</div>,
			);
		});
		return (
			<>
				<div
					className="home-links"
					id="home-links">
					<div className="hold ">
						<div className="more-hold">
							{output}
							<div className="more-title">
								{this.state.data.length !== 0 ? (
									<table
										cellPadding="0"
										cellSpacing="0"
										height="100%">
										<tbody>
											<tr>{this.textAsideOfPackages()}</tr>
										</tbody>
									</table>
								) : null}
							</div>

							<div className="clear"></div>
						</div>
						{UserType === "POSTR" ||
						UserType === "POSTB" ||
						UserType === "POSTB_SPLIT" ? (
							<Manager
								module="footer"
								view="list"></Manager>
						) : null}
					</div>
				</div>
				{UserType === "HYBRID_RESIDENTIAL_COST_CONTROL" &&
				landPageData.contractInfoCarrier.inListOfWhatuspCss ? (
					<div
						className="renewal-time customeClassDataFromContract"
						id="renewal-time"
						style={{ display: "block;" }}>
						Τα ΜΒ του προγράμματος θα ανανεωθούν στις{" "}
						<span className="customeClassDataFromContractDate">
							{sessionStorage.customerDataDate}
						</span>
					</div>
				) : null}
			</>
		);
	}

	getOsVersion(os) {
		let nAgt = navigator.userAgent;
		let nVer = navigator.appVersion;
		let osVersion = "-";
		switch (os) {
			case "Android":
				osVersion = /Android ([\.\_\d]+)/.exec(nAgt)[1];
				break;
			case "iOS":
				osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
				osVersion =
					osVersion[1] + "." + osVersion[2] + "." + (osVersion[3] | 0);
				break;
		}
		console.log("Agent operating system version: " + osVersion);
		return osVersion;
	}

	getOs() {
		let nAgt = navigator.userAgent;
		let os = "-";
		let clientStrings = [
			{ s: "Android", r: /Android/ },
			{ s: "iOS", r: /(iPhone|iPad|iPod)/ },
		];
		for (let id in clientStrings) {
			let cs = clientStrings[id];
			if (cs.r.test(nAgt)) {
				os = cs.s;
				break;
			}
		}
		console.log("Agent operating system: " + os);
		return os;
	}

	openDeepLink() {
		let dataFromCalls = JSON.parse(sessionStorage.getCustomerData).deepLinkData;
		let os = this.getOs();
		if (os === "Android") {
			let androidUrl = dataFromCalls.androidAppStoreUrl;
			console.log("Attempting to redirect to deep link " + androidUrl);
			sessionStorage.setItem("appropriateURL", androidUrl);
			window.location = androidUrl;
		} else if (os === "iOS") {
			console.log("Attempting to redirect to deep link");
			sessionStorage.setItem("appropriateURL", dataFromCalls.iosAppStoreUrl);
			window.location = dataFromCalls.iosAppStoreUrl;
		}
	}

	redirectOrActivateAndRedirect() {
		let popUpEligible = JSON.parse(sessionStorage.getCustomerData).deepLinkData
			.giftEligible;
		if (popUpEligible) {
			console.log(
				"User still on page after banner click. Attempting to activate gift and redirect to store.",
			);

			let url = CustomFunctions.restAPI("/page/activate");

			fetch(url)
				.then((res) => res.json())
				.then((data) => {
					console.log();
				})
				.catch(function () {
					console.log("Fail activate gift");
				});
		}
		window.location.replace(sessionStorage.appropriateURL);
	}

	tryToOpenDeepLinkOrRedirect() {
		let os = this.getOs();

		if (os === "iOS") {
			setTimeout(() => {
				this.redirectOrActivateAndRedirect();
			}, 1000);
			console.log("Attempting to open deep link after banner click");
			this.openDeepLink();
		} else {
			console.log("Attempting to open deep link after banner click");
			setTimeout(() => {
				this.redirectOrActivateAndRedirect();
			}, 1000);
			console.log("Attempting to open deep link after banner click");
			this.openDeepLink();
		}
	}

	isSupportedMobile() {
		let operatingSystem = this.getOs();
		let minAndroidVersion = JSON.parse(sessionStorage.getCustomerData)
			.deepLinkData.minimumAndroidVersion;
		let minIOSVersion = JSON.parse(sessionStorage.getCustomerData).deepLinkData
			.minimumIosVersion;

		let supportedClients = ["Android", "iOS"];
		let osIndex = supportedClients.indexOf(operatingSystem);
		if (osIndex != -1) {
			//Supported operating system

			let version = this.getOsVersion(operatingSystem);

			if (osIndex == 0) {
				//In case of Android
				return this.isOsVersionSupported(minAndroidVersion, version);
			} else if (osIndex == 1) {
				//In case of iOS
				return this.isOsVersionSupported(minIOSVersion, version);
			} else {
				//Invalid case
				console.log("Invalid action");
			}
		} else {
			//Unsupported operating system
			console.log(
				"No application available for operating system: " + operatingSystem,
			);
		}
		return false;
	}
	isOsVersionSupported(minSupportedVersion, agentVersion) {
		let supportedVersionArray = minSupportedVersion.split(".");
		let agentVersionArray = agentVersion.split(".");

		// avoid forEach() because there is no guarantee for the order it will iterate over the list
		for (let i = 0; i < supportedVersionArray.length; i++) {
			if (agentVersionArray[i] == "-") {
				//Assume it is a lower version than the supported
				// i.e. min = 4.6.1 | agent version = 4.6
				return false;
			} else if (agentVersionArray[i] > supportedVersionArray[i]) {
				// i.e. agent = 4.6 | minimum version = 4.5
				if (
					/Firefox/.test(navigator.userAgent) ||
					/CrossApp/.test(navigator.userAgent)
				) {
					console.log("Ineligible user agent" + navigator.userAgent);
					return false;
				} else {
					return true;
				}
			}
			//else go on with the iteration of following array element
		}
		//The agent version is exactly the same as the minimum supported version
		if (
			/Firefox/.test(navigator.userAgent) ||
			/CrossApp/.test(navigator.userAgent)
		) {
			console.log("Ineligible user agent" + navigator.userAgent);
			return false;
		} else {
			return true;
		}
	}

	render() {
		if (this.state.loaded) {
			let UserType = Functions["custom"]["getUserType"]();
			return (
				<>
					{UserType === "POSTB" ||
					UserType === "POSTB_SPLIT" ||
					UserType === "POSTR" ? (
						<Manager
							module="infoPanel"
							view="list"></Manager>
					) : (
						<Manager
							module="infoPanel"
							view="list"
							inputData={[this.props.restData]}></Manager>
					)}
					{this.createDataList()}
				</>
			);
		} else {
			return "";
		}
	}
}

export default AvailableData;
